module.exports = __webpack_public_path__ + "static/media/background-quem-somos.c349da72.png";